import React from "react";
import { useRef } from "react";
import Hero from "./hero";
import IndustryRecognitionBenefits from "./IndustryRecognition";
import AssessmentBox from "./AboutThisNvqAssessment";
import KeyFeaturesBox from "./KeyFeaturesBox";
import WhyChooseM2HSECarousel from "./WhyM2hse";
import FAQ from "./Faqs";
import CoursePricing from "./CoursePricing";
import EntryRequirement from "./EntryRequirements";
import HowItWorks from "./HowItsWork";
import FaqAndContact from "../../../Contact_Us/GetInTouch/FAQsandContactForm";
import Certification from "./Certification";
import { Helmet } from "react-helmet";

const OhsLevel7 = () => {
  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const title = "NVQ Level 7 Health and Safety Certificate | M2HSE Training";
  const description =
    "Get your NVQ Level 7 Health and Safety certificate with UK-accredited training in leadership, management, and construction. Apply for your Black CSCS Card now!";

  return (
    <div>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link
          rel="canonical"
          href="https://m2hse.co.uk/nvq-level-7-Strategic-Health-and-Safety-Leadership-and-Management"
        />
      </Helmet>
      <Hero onEnquireClick={scrollToContact} />

      <CoursePricing />
      <EntryRequirement />
      <FAQ />
      <HowItWorks />
      <AssessmentBox />
      <Certification />
      <IndustryRecognitionBenefits />
      <KeyFeaturesBox />
      <WhyChooseM2HSECarousel />
      <FaqAndContact ref={contactRef} />

      {/* <RelatedCourses /> */}
    </div>
  );
};

export default OhsLevel7;
